import { render, staticRenderFns } from "./switchModeContent.vue?vue&type=template&id=1299562e&"
import script from "./switchModeContent.vue?vue&type=script&lang=js&"
export * from "./switchModeContent.vue?vue&type=script&lang=js&"
import style0 from "./switchModeContent.vue?vue&type=style&index=0&id=1299562e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports